import { BaseControl } from "../base-control";

class PercentControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }

  async $onInit() {
    if (this.model?.value) {
      // TODO: revisit as discussed with Henry. Non QB providers won't work
      this.model.value = parseFloat((this.model.value * 100).toFixed(4));
    }
    await super.$onInit();
  }
  
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/percent-control/percent-control.component.html",
  controller: PercentControlCtrl
};